import React from 'react';
import { getPinName } from '../../ultils';
import { IS_INVERTED_PIN} from '../../constants/landing-page';
export const PinNameCellRender: React.FC = (props: any) => {
  let lastpinNameResolve = "";
  if(props.column.colId.includes("pin")){
    let pinNameStringResolve = getPinName(props,props.column.colId);
    let pinNameResolveArray: string[] = pinNameStringResolve?.split(",");
    let pinNameResolveArrayLength: number = pinNameResolveArray?.length - 1;
    //Add span with css overline to inverted pin(NOT) and normal span to normal pin.
    pinNameResolveArray?.forEach((item :string, index: number)  => {
        let pinNameAddSpan = "";
            if(!item.includes(IS_INVERTED_PIN)){
                pinNameAddSpan = `<span>${item}${index === pinNameResolveArrayLength ? "" : ","}</span>`;
            }
            else pinNameAddSpan= `<span style='text-decoration: overline'>${item.replace(IS_INVERTED_PIN,'')}${index === pinNameResolveArrayLength ? "" : ","}</span>`;
        lastpinNameResolve += pinNameAddSpan;
    })
  }
  return (
    <>
       <div  dangerouslySetInnerHTML={{ __html: lastpinNameResolve }} />
    </>)
}